import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import moment from 'moment';
import useWindow from '../../hooks/useWindow'
import { singleDoubleChartWidth, chartHeight, post2, list2 } from '../../services';
import exportingModule from "highcharts/modules/exporting";
import exportDataModule from 'highcharts/modules/export-data'
exportingModule(Highcharts);
exportDataModule(Highcharts);

export const BalanceChart = ({ start, data, title, isSingle=false }) => {

    const [options, setOptions] = useState({})
    const size = useWindow()

    const [exp, setExp] = useState(false)
    useEffect(() => {
        async function fetch() {
            const auth = await list2('auth')
            setExp(auth === true)
        }
        fetch()
    }, [])

    useEffect(() => {
        if (!data || data.length === 0) return
        const end = data[data.length - 1].date
        const text = `${moment(start).format('MMM YY')} - ${moment(end).format('MMM YY')} (MBD)`
        const options = {
            chart:  { 
                width: singleDoubleChartWidth(size.width, isSingle),
                height: chartHeight(size.height)
            },
            exporting: exp ? {
                buttons: {
                    contextButton: {
                        enabled: true,
                        align: 'left',
                        menuItems: ["downloadPNG", "downloadPDF", "downloadCSV", "separator",
                            {
                                text: 'Send Email',
                                onclick: function() {
                                    const csv = this.getCSV()
                                    const html = this.getSVG()
                                    const title = this.getFilename()
                                    post2('user/export_file', { csv, html, title })
                                }
                            }
                        ]
                    }
                }
            } : {
                buttons: {
                    contextButton: {
                        enabled: false
                    }    
                }
            },
            title: {
                text: `${title}: Gross Balance`,
                align: 'center'
            },
            subtitle: {
                text,
                align: 'right'
            },
            xAxis: {
                title: { text: '' },
                categories: data.map(dat => moment(dat.date).format('MMM YY'))
            },
            tooltip: {
                formatter: function () {
                    return this.points.reduce((pre, cur) => `${pre}<br /><div><b>${cur.series.userOptions.name}:</b>&nbsp;${Math.abs(cur.y)}</div>`, `<b>${this.x}</b><br />`)
                },
                shared: true
            },
            yAxis: [
                {
                    title: { text: '' },
                    stackLabels: {
                        enabled: true,
                        crop: false,
                        overflow: 'allow',
                        style: {
                            fontWeight: 'bold',
                            color: 'gray'
                        }
                    }
                },
                {
                    title: { text: '' },
                    opposite: true
                }
            ],
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            legend:{
                maxHeight: 70
            },
            series: [
                {
                    name: 'Production',
                    type: 'column',
                    yAxis: 0,
                    data: data.map(dat => +dat.production)
                },
                {
                    name: 'Consumption',
                    type: 'column',
                    yAxis: 0,
                    data: data.map(dat => -dat.consumption)
                },
                {
                    name: 'Balance',
                    type: 'spline',
                    yAxis: 1,
                    data: data.map(dat => +dat.balance)
                },
                {
                    name: '5Y Median',
                    type: 'spline',
                    yAxis: 1,
                    data: data.map(dat => +dat.balance_median)
                },
            ]
        }
        setOptions(options)
        console.log(options)
    }, [start, data, title, size, isSingle, exp]);

    return (
    <div>
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    </div>)
}